export default __webpack_public_path__ + "static/FReg-Goal1-8343cb7e89b48cc404206fb954ed8b75.jpg";